export { default } from './NewsletterEdit'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Newsletter/NewsletterEdit/index.js